import type { TiendaBaseConfigDTO } from "../templates/types";

export const LG = {
    color: {
        cream50: "#ffffff",
        cream100: "#f9f9fc",
        cream200: "#f0f1f5",
        cream300: "#e8eaf0",
        cream400: "#dde2ea",
        cream: "#f9f9fc",
        creamLight: "#ffffff",
        text: "#1a1c1e",
        ink800: "#2d3038",
        ink700: "#404751",
        textSecondary: "#404751",
        textMuted: "#707882",
        textDisabled: "#bfc7d2",
        surface: "rgba(255, 255, 255, 0.70)",
        surfaceHover: "rgba(255, 255, 255, 0.85)",
        surfaceStrong: "rgba(255, 255, 255, 0.90)",
        surfaceDark: "rgba(0, 58, 92, 0.55)",
        border: "rgba(255, 255, 255, 0.40)",
        borderStrong: "rgba(255, 255, 255, 0.60)",
        divider: "rgba(191, 199, 210, 0.50)",
        gold: "#00629c",
        goldSoft: "#cfe5ff",
        buttonDark: "#00629c",
        buttonDarkText: "#ffffff",
    },
    radius: {
        xs: "12px",
        sm: "16px",
        md: "24px",
        lg: "32px",
        xl: "40px",
        pill: "999px",
    },
    blur: "blur(20px) saturate(180%)",
    blurLight: "blur(16px) saturate(180%)",
    blurStrong: "blur(28px) saturate(200%)",
    shadow: {
        sm: "0 4px 14px -6px rgba(0,58,92,0.12), inset 0 1px 0 rgba(255,255,255,0.9)",
        md: "0 12px 40px -12px rgba(0,58,92,0.10), 0 2px 6px -2px rgba(0,58,92,0.06), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.02)",
        lg: "0 30px 80px -24px rgba(0,58,92,0.16), 0 8px 24px -8px rgba(0,58,92,0.08), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.02)",
        xl: "0 40px 100px -40px rgba(0,58,92,0.20), inset 0 1px 0 rgba(255,255,255,0.6)",
    },
    transition: "all 0.25s ease",
    fontFamily: '"Plus Jakarta Sans", "Manrope", system-ui, sans-serif',
};

export function hidratarLG(config: TiendaBaseConfigDTO): void {
    const { theme } = config;

    Object.assign(LG.color, {
        cream50: theme.colores.vchFondoPagina,
        cream100: theme.colores.vchFondoPagina,
        cream200: theme.colores.vchFondoPaginaSecundario,
        cream300: theme.colores.vchFondoSuperficie,
        cream400: theme.colores.vchFondoSuperficieElevada,
        cream: theme.colores.vchFondoPagina,
        creamLight: theme.colores.vchFondoPagina,
        text: theme.colores.vchTextoPrincipal,
        ink800: theme.colores.vchTextoPrincipal,
        ink700: theme.colores.vchTextoSecundario,
        textSecondary: theme.colores.vchTextoSecundario,
        textMuted: theme.colores.vchTextoMuted,
        textDisabled: theme.inputs.vchDisabled,
        surface: theme.cards.vchFondo,
        surfaceHover: theme.colores.vchSeleccion,
        surfaceStrong: theme.colores.vchFondoSuperficieElevada,
        surfaceDark: theme.colores.vchOverlay,
        border: theme.colores.vchBorde,
        borderStrong: theme.colores.vchBordeFuerte,
        divider: theme.colores.vchDivider,
        gold: theme.colores.vchMarcaPrincipal,
        goldSoft: theme.colores.vchMarcaSecundaria,
        buttonDark: theme.botones.vchPrimaryBg,
        buttonDarkText: theme.botones.vchPrimaryTexto,
    });

    Object.assign(LG.radius, {
        xs: `${theme.radios.intXs}px`,
        sm: `${theme.radios.intSm}px`,
        md: `${theme.radios.intMd}px`,
        lg: `${theme.radios.intLg}px`,
        xl: `${theme.radios.intXl}px`,
        pill: "999px",
    });

    Object.assign(LG.shadow, {
        sm: theme.sombras.vchSm,
        md: theme.sombras.vchMd,
        lg: theme.sombras.vchLg,
        xl: theme.sombras.vchLg,
    });

    LG.blur = theme.blur.vchNormal;
    LG.blurLight = theme.blur.vchNormal;
    LG.blurStrong = theme.blur.vchFuerte;
    LG.fontFamily = theme.tipografia.vchFontFamilyBase;
}

export const formatMoney = (value?: number) => {
    if (!value) return "$0";
    return `$${value.toLocaleString("es-AR", { maximumFractionDigits: 0 })}`;
};
